<div class="wrapper-570">
  <h1 class="f-size-30 font-weight-bold f-color-dark">{{ title }}</h1>
  <p class="lead f-size-16">
    {{ subtitle }}
    <a *ngIf="anchor" [routerLink]="anchor?.link">{{ anchor?.text }}</a>
  </p>
</div>
